jQuery(document).ready(function () {
  jQuery(".mod-quote-v1-main").each(function (index) {
    let slider = jQuery(this).find(".mod-quote-v1-list");
    let prev_arrow = jQuery(this).find(".mod-quote-v1-list-prev");
    let next_arrow = jQuery(this).find(".mod-quote-v1-list-next");
    jQuery(slider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: jQuery(prev_arrow),
      nextArrow: jQuery(next_arrow),
      dots: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
           arrows:false,
           autoplay:true,
           autoplaySpeed: 5000,
          },
        },
      ],
    });
  });
});
